// extracted by mini-css-extract-plugin
export default {"tableHeaderRow":"k8sr96Oizs9mld1E1oS8","tableHeaderColumn":"IaexppjK5I1qt8cTvPj9","tableBodyRow":"XOr_vaFut1CsCsS74b0V","tableBodyColumn":"kBtI4aXBHL4iXVWtMR5b"};